module.exports = __webpack_public_path__ + "img/buttermilk.ddf1934d.jpeg";